import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import openApiSpec from "../../docs/openapi.json";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Home } from "lucide-react";
import { Button } from "@/components/ui/button";

const ApiDocs = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      {/* Large accessible Back button for gaze/switch users */}
      <div className="sticky top-0 z-50 bg-white border-b border-gray-200 p-4 flex gap-4">
        <Button
          size="lg"
          variant="outline"
          onClick={() => navigate(-1)}
          className="h-14 px-6 text-lg rounded-xl gap-2"
        >
          <ArrowRight className="w-5 h-5" />
          <span>Back</span>
        </Button>
        <Button
          size="lg"
          variant="outline"
          onClick={() => navigate("/")}
          className="h-14 px-6 text-lg rounded-xl gap-2"
        >
          <Home className="w-5 h-5" />
          <span>Home</span>
        </Button>
      </div>
      <SwaggerUI spec={openApiSpec} />
    </div>
  );
};

export default ApiDocs;
